
const ip = 'api.naduvida.com.br';
const port = '';

const server = 'https://'+ip+port+'/';
const static_img = 'https://'+ip+port+'/static/img/';

const abbreviations = [
    {"Abrev.": "Abreviatura."},
    {"adj.": "Adjetivo."},
    {"adj. e s.m.": "Adjetivo e substantivo masculino."},
    {"adj.2g.": "Adjetivo de dois gêneros."},
    {"adj.2g. e s.2g.": "Adjetivo de dois gêneros e substativo de dois gêneros."},
    {"adv.": "Advérbio."},
    {"Anat.": "Anatomia."},
    {"Arqueol.": "Arqueologia."},
    {"Arquit.": "Arquitetura."},
    {"Art.": "Arte."},
    {"art.": "Artigo."},
    {"Astrol.": "Astrologia."},
    {"Astron.": "Astronomia."},
    {"Biol.": "Biologia."},
    {"Bioquím": "Bioquímica."},
    {"Bot.": "Botânica."},
    {"Bras.": "Brasileirismo."},
    {"Chul.": "Chulo."},
    {"conj.": "Conjunção."},
    {"CUL.": "Culinária."},
    {"DESUS.": "Desusado."},
    {"ECOL.": "Ecologia."},
    {"ECON.": "Economia."},
    {"ESPORT.": "Esporte."},
    {"etc. 	et cetera;": "outras coisas."},
    {"FARM.": "Farmacologia."},
    {"Fem.": "Feminino."},
    {"FIG.": "Figurado."},
    {"FILOS.": "Filosofia."},
    {"FÍS.": "Física."},
    {"FÍS. E QUÍM.": "Física e Química."},
    {"GEOGR.": "Geografia."},
    {"GEOL.": "Geologia."},
    {"GEOM.": "Geometria."},
    {"GRAM.": "Gramática."},
    {"HIST.": "História."},
    {"INFORMÁT.": "Informática."},
    {"interj.": "Interjeição."},
    {"JUR.": "Jurídico."},
    {"LITER.": "Literatura."},
    {"loc. adv.": "Locução adverbial."},
    {"LUS.": "Lusitanismo."},
    {"MAT.": "Matemática."},
    {"MED.": "Medicina."},
    {"MIT.": "Mitologia."},
    {"MÚS.": "Música."},
    {"num.": "Numeral."},
    {"Onomat": "Onomatopeia."},
    {"PALEO.": "Paleontologia."},
    {"PEJOR.": "Pejorativo."},
    {"Pl.": "Plural."},
    {"POÉT.": "Poético."},
    {"POP.": "Popular."},
    {"POR EXT.": "Por extensão."},
    {"prep.": "Preposição."},
    {"pron.": "Pronome."},
    {"PSICOL.": "Psicologia."},
    {"QUÍM.": "Química."},
    {"RELIG.": "Religião."},
    {"s.2g.": "Substantivo de dois gêneros."},
    {"s.2g.2n.": "Substantivo de dois gêneros e dois números."},
    {"s.f.": "Substantivo feminino."},
    {"s.m.": "Substantivo masculino."},
    {"s.m.pl.": "Substantivo masculino plural."},
    {"Símb.": "Símbolo."},
    {"v.pred": "Verbo predicativo."},
    {"v.pron.": "Verbo pronominal."},
    {"v.i.": "Verbo intransitivo."},
    {"v.t.": "Verbo transitivo."},
    {"v.t. e v.i.": "Verbo transitivo e intransitivo."},
    {"VETER.": "Veterinária."},
    {"ZOOL.": "Zoologia."}
];
// has a hash
const abbr = abbreviations.reduce((obj, item) => {
    let key = Object.keys(item);
    return Object.assign(obj, {[key]: item[key]}, {})
});

const title = 'Mini dicionário da Lingua Portuguesa'

export {server, static_img, abbreviations, abbr, title};


// WEBPACK FOOTER //
// ./src/constants.jsx